<dx-popup
    #denyFromWorkflowEditorPopup
    minWidth="150px"
    minHeight="150px"
    width="40%"
    height="50%"
    title="Deny Actions"
    [showCloseButton]="true"
    [shading]="true"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" labelLocation="top" [colCount]="1" [scrollingEnabled]="true">
                        <dxi-item>
                            <dxo-label text="Reason to deny this Invoice"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area
                                    [maxLength]="denyWorkflowReasonMaxLength"
                                    [height]="110"
                                    class="text-area-content"
                                    [value]="reasonToDeny"
                                    (onKeyUp)="onReasonValueChanged($event)"
                                ></dx-text-area>
                                <div class="text-alignment">
                                    {{ getCharacterCount() }}/{{ denyWorkflowReasonMaxLength }}
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate>
                                <fieldset class="field-set dx-theme-border-color">
                                    <legend>How do you want to DENY this Workflow Job ?</legend>
                                    <div class="fieldset-container">
                                        <dx-radio-group
                                            valueExpr="action"
                                            displayExpr="text"
                                            [items]="denyActions"
                                            [(value)]="selectedDenyAction"
                                        ></dx-radio-group>
                                    </div>
                                </fieldset>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%" class="top-padding">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onCancelClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Ok"
                                    [icon]="iconCheck"
                                    (onClick)="onOkClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
